<template>
  <!--团队管理-->
  <div>
    <a-card v-if="seeEnable" :bordered="false" style="position: relative;">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form"  >
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="用户名" style="margin-left: 40px;" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input  v-model="queryParam.loginName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅姓名" style="margin-left:30px"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input  v-model="queryParam.userName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input  v-model="queryParam.phonenumber"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.workerType"  >
                  <a-select-option :title="type.label"  v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-row>
                <a-form-item style="margin-left:26px;" label="服务区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-col :span="8">
                    <a-select v-decorator="['serviceProvinceId']" @change="haveProvince1">
                      <a-select-option :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{type.provinceName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="8">
                    <a-select v-decorator="['serviceCityId']" @change="haveProvince2">
                      <a-select-option :title="type.cityName" v-for="type in data2" :key="type.cityCode">{{type.cityName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="8">
                    <a-select v-decorator="['serviceDistrictId']" >
                      <a-select-option :title="type.areaName" v-for="type in data3" :key="type.areaCode">{{type.areaName}}</a-select-option>
                    </a-select>
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
            <a-col :span="6">
              <a-form-item label="服务类型" style="margin-left: 26px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.installName"  >
                  <a-select-option  :title="type.label" v-for="type in restaurantTypes1" :key="type.label">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅等级" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.techLevel">
                  <a-select-option :title="type.label" v-for="type in restaurantTypes2" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-row>
                <a-form-item style="margin-left:26px;" label="师傅得分" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-col :span="11">
                    <a-input  v-model="queryParam.userStartScore" />
                  </a-col>
                  <a-col :span="2">
                    <span style="margin:0 5px">-</span>
                  </a-col>
                  <a-col :span="11">
                    <a-input  v-model="queryParam.userEndScore" />
                  </a-col>
                </a-form-item>
              </a-row>

            </a-col>
            <a-col :span="6">
              <a-form-item style="margin-left:30px" label="接单模式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.receiptTypeName"  >
                  <a-select-option :title="type.label" v-for="type in restaurantTypes3" :key="type.label">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="标签" style="margin-left: 54px" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-select v-model="queryParam.masterLabelName" >
                  <a-select-option :title="type.installLabelName"  v-for="type in data" :key="type.installLabelName">{{type.installLabelName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <transition name="fade">
            <div v-if="show">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-row>
                    <a-form-item style="margin-left:26px;" label="注册地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-col :span="6">
                        <a-select v-decorator="['provinceId']"  @change="haveProvince3">
                          <a-select-option :title="type.provinceName"  v-for="type in data1" :key="type.provinceCode">{{type.provinceName}}</a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="6">
                        <a-select v-decorator="['cityId']"  @change="haveProvince4">
                          <a-select-option :title="type.cityName"  v-for="type in data4" :key="type.cityCode">{{type.cityName}}</a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="6">
                        <a-select v-decorator="['districtId']" >
                          <a-select-option :title="type.areaName" v-for="type in data5" :key="type.areaCode">{{type.areaName}}</a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="6">
                        <a-input v-model="queryParam.detailedAddress" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="注册情况" style="margin-left: 26px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.status" >
                      <a-select-option value="2">
                        未通过
                      </a-select-option>
                      <a-select-option value="0">
                        未审核
                      </a-select-option>
                      <a-select-option value="1">
                        已通过
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="合同文件" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.hasContract" >
                      <a-select-option value="0">
                        无
                      </a-select-option>
                      <a-select-option value="1">
                        有
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item style="margin-left:26px;" label="提现周期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.cashCycle"  >
                      <a-select-option :title="type.label"  v-for="type in restaurantTypes4" :key="type.code">{{type.label}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item style="margin-left:30px" label="提现方式"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.cashStatus" >
                      <a-select-option :title="type.label"  v-for="type in restaurantTypes5" :key="type.code">{{type.label}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-row>
                    <a-col :span="6">
                      <a-select v-model="queryParam.timeType1"  allowClear="true">
                        <a-select-option :title="type.label"   v-for="type in options" :key="type.value">
                          {{type .label}}
                        </a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="18">
                      <a-range-picker
                        v-model="queryParam2.time"
                        :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
                        format="YYYY-MM-DD"
                        :placeholder="['开始时间', '结束时间']"
                        @change="onChange1"
                        @ok="onOk"
                        style="width: 100%"
                      />
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="6">
                  <a-row>
                    <a-col :span="6">
                      <a-select v-model="queryParam.timeType2"  allowClear="true">
                        <a-select-option :title="type.label"  v-for="type in options" :key="type.value">
                          {{type .label}}
                        </a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="18">
                      <a-range-picker
                        v-model="queryParam2.time2"
                        :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
                        format="YYYY-MM-DD"
                        :placeholder="['开始时间', '结束时间']"
                        @change="onChange2"
                        @ok="onOk"
                        style="width:100%"
                      />
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item style="margin-left:12px;" label="渠道负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-input v-model="queryParam.masterProvinceName" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item style="margin-left:16px" label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select  show-search v-model="queryParam.masterLeadingName">
                      <a-select-option :title="type.userName"   v-for="type in pullDown" :key="type.userId">{{type.userName}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-row>
                    <a-form-item label="保证金" style="margin-left:40px" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                      <a-col :span="11">
                        <a-input  v-model="queryParam.bondBegin" />
                      </a-col>
                      <a-col :span="2">
                        <span style="margin:0 5px">-</span>
                      </a-col>
                      <a-col :span="11">
                        <a-input  v-model="queryParam.bondEnd" />
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="区域置顶" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam.isTop" >
                      <a-select-option value="0">
                        不是
                      </a-select-option>
                      <a-select-option value="1">
                        是
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item style="margin-left:54px;" label="私密" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-select v-model="queryParam.privateMaster" >
                      <a-select-option value="0">
                        不是
                      </a-select-option>
                      <a-select-option value="1">
                        是
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-row>
                    <a-form-item label="近30天投诉率"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-col :span="11">
                        <a-input  v-model="queryParam.complaintRateBegin" />
                      </a-col>
                      <a-col :span="2">
                        <span style="margin:0 5px">-</span>
                      </a-col>
                      <a-col :span="11">
                        <a-input  v-model="queryParam.complaintRateEnd" />
                      </a-col>

                    </a-form-item>
                  </a-row>

                </a-col>
                <a-col :span="6">
                  <a-form-item label="团队名称" style="margin-left: 26px" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-input v-model="queryParam.teamName" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="团员姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-input v-model="queryParam.memberName" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="团员联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-input v-model="queryParam.memberPhone" />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
          </transition>
          <a-row>
            <a-col :span="3" :offset="11">
              <span style="cursor:pointer" v-on:click="show =!show " v-if="!show"><a-icon type="down-circle" theme="twoTone" style="fontSize:24px"/></span>
              <span style="cursor:pointer" v-on:click="show =!show " v-if="show"><a-icon type="up-circle" theme="twoTone" style="fontSize:24px"/></span>
            </a-col>
            <a-col :span="10" style="text-align: right">
            <span>
              <a-button htmlType="submit"  type="primary" @click="Update()">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetdata()">清空</a-button>
              <a-button v-if="exportEnable" style="margin-left: 8px" type="primary" @click="ExportTeam()">导出Excel</a-button>
            </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        style="margin-top: 20px"
        size="default"
        ref="table"
        rowKey="modelId"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 4200 }"
        bordered
      >
      <span slot="installType" slot-scope="text, record">
         <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">{{type.label}}</td>
      </span>
        <span slot="userName" slot-scope="text, record">
        <span class="hover">{{text}} </span>
        <a title="复制"><a-icon type="copy" class="copy"  @click="Copys(record)"/></a>
      </span>
        <span slot="action" slot-scope="text, record">
        <a v-if="editEnabel" @click="handleEdit(record)">编辑 <a-divider type="vertical" v-if="detailEnable || viewEnable || addEnable"/></a>
        <a v-if="detailEnable" @click="handleSee(record)">查看 <a-divider type="vertical" v-if="viewEnable || addEnable"/></a>
        <a v-if="viewEnable" @click="handleAcc(record)">查看子账号 <a-divider type="vertical" v-if="addEnable"/></a>
        <a v-if="addEnable" @click="handleAdd(record.userId)">新增团队</a>
      </span>
      </s-table>
      <view-editing ref="modal3" @ok="handleOk"></view-editing>
      <team-add ref="modal2" @ok="handleOk"></team-add>
      <team-details ref="modal4" @ok="handleOk"></team-details>
      <masterlist-edit ref="Mastermodal"></masterlist-edit>
      <sub-account ref="modal9" @ok="handleOk"></sub-account>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>

<script>
  import { STable } from '@/components'
  import { queryMaster,selectALLInstallLabel,addMaster,blackMaster } from '@/api/master/MasterList'
  import { getSelectAllProvince,getelectCityName,getelectAreaName,forbiddenMaster,enableMaster } from '@/api/master/MasterList'
  import ViewEditing from './modules/ViewEditing.vue'
  import TeamDetails from './modules/TeamDetails.vue'
  import TeamAdd from './modules/TeamAdd.vue'
  import NoAuthority from '../enterprise/NoAuthority'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  import { list,TeamExportTeam } from '@/api/master/TeamManagement'
  import MasterlistEdit from './modules/MasterlistEdit'
  import { findByDeptId } from '@/api/enterprise/user'
  import {selectFindAll} from '@/api/enterprise/enterprise'
  import SubAccount from './modules/SubAccount.vue'
  import store from '@/store'
  import moment from 'moment'

  const options = [
    { label: '注册时间', value: 'createTime' },
    { label: '审核时间', value: 'auditTime' },
    { label: '合同起始时间', value: 'contractStartTime' },
    { label: '合同到期时间', value: 'contractEndTime' },
    { label: '保证金缴纳时间', value: 'bondTime' },
    { label: '接单时间', value: 'receiveTime' },
    { label: '销单时间', value: 'saleTime' },
  ];

  export default {
    name: 'TeamManagement',
    components: {
      STable,
      ViewEditing,
      TeamAdd,
      TeamDetails,
      MasterlistEdit,
      SubAccount,
      NoAuthority
    },
    data () {
      return {
        pullDown:'',
        show:false,
        options,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        queryParam2:{},
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            width: '70px',
            align:'center'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
          {
            title: '团队数量',
            dataIndex: 'teamNum',
            align:'center'
          },
          {
            title: '团队人数',
            dataIndex: 'teamPersonNum',
            align:'center'
          },
          {
            title: '姓名',
            dataIndex: 'userName',
            align:'center',
            scopedSlots: { customRender: 'userName' },
          },
          {
            title: '性别',
            dataIndex: 'sexName',
            align:'center'
          },
          {
            title: '联系方式',
            dataIndex: 'phonenumber',
            align:'center'
          },
          {
            title: '标签',
            dataIndex: 'masterLabelName',
            align:'center'
          },
          {
            title: '师傅类型',
            dataIndex: 'workerTypeName',
            align:'center'
          },
          {
            title: '得分',
            dataIndex: 'userScore',
            align:'center'
          },
          {
            title: '师傅等级',
            dataIndex: 'techLevelName',
            align:'center'
          },
          {
            title: '服务类型',
            dataIndex: 'installName',
            align:'center'
          },
          {
            title: '省',
            dataIndex: 'provinceName',
            align:'center'
          },
          {
            title: '市',
            dataIndex: 'cityName',
            align:'center'
          },
          {
            title: '区',
            dataIndex: 'districtName',
            align:'center'
          },
          {
            title: '街道',
            dataIndex: 'detailedAddress',
            align:'center'
          },
          {
            title: '接单方式',
            dataIndex: 'receiptTypeName',
            align:'center'
          },
          {
            title: '提现周期',
            dataIndex: 'cashCycleName',
            align:'center'
          },
          {
            title: '提现方式',
            dataIndex: 'cashStatusName',
            align:'center'
          },
          {
            title: '接单量',
            dataIndex: 'receiveOrder',
            align:'center'
          },
          {
            title: '销单量',
            dataIndex: 'writeOrder',
            align:'center'
          },
          {
            title: '师傅等级',
            dataIndex: 'techLevelName',
            align:'center'
          },
          {
            title: '近30天投诉率',
            dataIndex: 'complaintRateRecent',
            align:'center'
          },
          {
            title: '已完成金额',
            dataIndex: 'completePrice',
            align:'center'
          },
          {
            title: '待入账金额',
            dataIndex: 'pendingPrice',
            align:'center'
          },
          {
            title: '可提现金额',
            dataIndex: 'cashPrice',
            align:'center'
          },
          {
            title: '已完成金额',
            dataIndex: 'completePrice',
            align:'center'
          },
          {
            title: '保证金',
            dataIndex: 'bond',
            align:'center'
          },
          {
            title: '缴纳时间',
            dataIndex: 'bondTime',
            align:'center'
          },
          {
            title: '合同文件',
            dataIndex: 'hasContract',
            align:'center'
          },
          {
            title: '合同有效期',
            dataIndex: 'contractDuration',
            align:'center'
          },
          {
            title: '师傅负责人',
            dataIndex: 'masterLeadingName',
            align:'center'
          },
          {
            title: '渠道负责人',
            dataIndex: 'masterProvinceName',
            align:'center'
          },
          {
            title: '审核时间',
            dataIndex: 'auditTime',
            align:'center'
          },
          {
            title: '审核人',
            dataIndex: 'auditByName',
            align:'auditByName'
          },
          {
            title: '注册情况',
            dataIndex: 'status',
            align:'center'
          },
          {
            title: '注册时间',
            dataIndex: 'createTime',
            align:'center'
          },
          {
            title: '注册人',
            dataIndex: 'createByName',
            align:'center'
          },
        ],
        loadData: parameter => {
          return list(Object.assign(parameter, this.queryParam))
        },
        confirmLoading: false,
        fileList: [],
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        pagination: false,
        loading: false,
        visible:false,
        record:'',
        textArea:'',
        restaurantTypes:[],
        restaurantTypes1:[],
        restaurantTypes2:[],
        restaurantTypes3:[],
        restaurantTypes4:[],
        data:[],
        data1:[],
        data2:[],
        data3:[],
        data4:[],
        data5:[],
        data6:[],
        addEnable: checkPermission('master:teamList:add'),
        editEnabel: checkPermission('master:teamList:edit'),
        removeEnable: checkPermission('master:teamList:delete'),
        exportEnable:checkPermission('master:teamList:export'),
        seeEnable:checkPermission('master:teamList:see'),
        detailEnable:checkPermission('master:team:detail'),
        viewEnable:checkPermission('master:teamList:childAccount:view'),
      }
    },
    filters: {
    },
    async created () {
      // if(store.getters.userType=='55'){
      //   this.handleSee()
      // }
      console.log(store.getters,'store.getters')
      //师傅负责人
      findByDeptId('106').then(res=>{
        this.pullDown=res
      })
      // this.$nextTick(()=>{
      //   document.body.addEventListener('keyup', e => {
      //     if (e.keyCode == 13) {
      //       //this.Update()
      //     }
      //   })
      // })
      selectFindAll({dictTypes:'install_type,worker_type,tech_level,receipt_type,cash_cycle,cash_status'}).then(res=>{
      this.restaurantTypes = [];
      this.restaurantTypes1 = [];
      this.restaurantTypes2 = [];
      this.restaurantTypes3 = [];
      this.restaurantTypes4 = [];
      this.restaurantTypes5 = [];
      this.restaurantOperTypeMap = res.worker_type
      this.restaurantOperTypeMap1 = res.install_type
      this.restaurantOperTypeMap2 = res.tech_level
      this.restaurantOperTypeMap3 =res.receipt_type
      this.restaurantOperTypeMap4 = res.cash_cycle
      this.restaurantOperTypeMap5 = res.cash_status
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap2.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes2.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap3.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes3.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap4.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes4.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap5.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes5.push({code: value.dictValue, label: value.dictLabel})
      })

      })

      // 标签
      selectALLInstallLabel().then(res=>{
        // console.log(res.data)
        this.data = res.data
      })
      // 省
      getSelectAllProvince().then(res=>{
        // console.log(res)
        this.data1=res.rows
      })
    },
    // destroyed () {
    //   this.$nextTick(()=>{
    //     document.body.removeEventListener('keyup', e => {})
    //   })
    // },
    methods: {
      moment,
      handleAcc(value){
        this.$refs.modal9.add(value.userId)
      },
      //查询
      Update(){
        this.queryParam.cityId=this.form.getFieldValue('cityId')
        this.queryParam.districtId=this.form.getFieldValue('districtId')
        this.queryParam.provinceId=this.form.getFieldValue('provinceId')

        this.queryParam.serviceCityId=this.form.getFieldValue('serviceCityId')
        this.queryParam.serviceDistrictId=this.form.getFieldValue('serviceDistrictId')
        this.queryParam.serviceProvinceId=this.form.getFieldValue('serviceProvinceId')

        this.$refs.table.refresh(true)
      },
      //导出
      ExportTeam(){
        this.queryParam.cityId=this.form.getFieldValue('cityId')
        this.queryParam.districtId=this.form.getFieldValue('districtId')
        this.queryParam.provinceId=this.form.getFieldValue('provinceId')

        this.queryParam.serviceCityId=this.form.getFieldValue('serviceCityId')
        this.queryParam.serviceDistrictId=this.form.getFieldValue('serviceDistrictId')
        this.queryParam.serviceProvinceId=this.form.getFieldValue('serviceProvinceId')

        var str=process.env.VUE_APP_API_BASE_URL + '/master/TeamMaster/exportTeam?pageNum=1&pageSize=10'
        for(let i in this.queryParam ){
          if(this.queryParam[i]!=undefined){
            str=str+'&'+i+'='+this.queryParam[i]
          }
        }
        str=str+'&token='+this.headers.token
        window.open(str)
        // TeamExportTeam(this.queryParam).then(res=>{
        //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        //   const a = document.createElement('a')
        //   // 生成文件路径
        //   let href = window.URL.createObjectURL(blob)
        //   a.href = href
        //   let fileName = '团队管理'
        //   // 文件名中有中文 则对文件名进行转码
        //   a.download = decodeURIComponent(fileName)
        //   // 利用a标签做下载
        //   document.body.appendChild(a)
        //   a.click()
        //   document.body.removeChild(a)
        //    window.URL.revokeObjectURL(href)
        //
        // })
      },
  resetdata(){
        this.form.resetFields()
        this.queryParam={}
        this.queryParam2={}
        this.Update()
      },
      handleEdit(v){
        this.$nextTick(()=>{
          this.$refs.Mastermodal.edit(v,'1')
        })
      },
      // 复制
      Copys(val){
        // console.log(val,'点击复制')
        this.copyData=`师傅姓名:`+val.userName+'\n'+`联系方式:`+val.phonenumber
        this.handcopy(this.copyData)
      },
      handcopy(data){
        let url = data;
        let oInput = document.createElement('textArea');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        // console.log(oInput.value)
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.success('复制成功')
        oInput.remove()
      },
      //查看
      handleSee(record){
        this.$nextTick(()=>{
          this.$refs.modal3.see(record)
        })
      },
      handleAdd (v) {
        this.$nextTick(()=>{
          this.$refs.modal2.add(v)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onChange1(value, dateString) {
        this.queryParam.timeBegin1=dateString[0]
        this.queryParam.timeEnd1=dateString[1]
      },
      onChange2(value, dateString) {
        this.queryParam.timeBegin2=dateString[0]
        this.queryParam.timeEnd2=dateString[1]
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      haveProvince1(e){
        this.data2=[]
        this.data3=[]
        this.form.setFieldsValue({
          'serviceCityId':'',
          'serviceDistrictId':'',
        })
        getelectCityName({provinceCode:e}).then(res=>{
          // console.log(res)
          this.data2=res.rows
        })
      },
      haveProvince2(e){
        this.data3=[]
        this.form.setFieldsValue({
          'serviceDistrictId':'',
        })
        getelectAreaName({cityCode:e}).then(res=>{
          this.data3=res.rows
        })
      },
      haveProvince3(e){
        this.data4=[]
        this.data5=[]
        this.form.setFieldsValue({'cityId':''})
        this.form.setFieldsValue({'districtId':''})
        getelectCityName({provinceCode:e}).then(res=>{
          // console.log(res)
          this.data4=res.rows
        })
      },
      haveProvince4(e){
        this.data5=[]
        this.form.setFieldsValue({'districtId':''})
        getelectAreaName({cityCode:e}).then(res=>{
          // console.log(res)
          this.data5=res.rows
        })
      },
      showState (userId, forbiddenStatus) {
        if (forbiddenStatus == 0) {
          forbiddenMaster({ 'userId': userId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (forbiddenStatus == 1) {
          enableMaster({ 'userId': userId }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('启动成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      // 拉黑
      handleDeploy(record) {
        console.log(record)
        this.record = record
        this.visible=true
      },
      handleSubmit () {
        if (this.textArea == ''){
          alert('请输入拉入黑名单的原因！')
        } else{
          blackMaster({userId:this.record.userId,reason:this.textArea}).then(res => {
            if (res.code === 0) {
              this.$message.success('拉黑成功')
              this.handleOk()
              this.visible=false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      handleChange(info) {
        // console.log(info)
        if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          this.$message.success('上传成功')

        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      },
      delByIds (modelId) {

      },
    },
    watch: {
    }
  }
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; }
  /deep/ .ant-table td{  padding: 4px 16px;}
  /*.trebtn{
    width: 140px;
    color: white;
    background-color: #17A4E1;
    position: absolute;
    font-size: 15px;
    top: -90px;
    right: 100px;
  }*/
  .trebtn{
    /*width: 140px;*/
    /*color: white;*/
    /*background-color: #17A4E1;*/
    /*font-size: 15px;*/
    /*top: -90px;*/
    right: 100px;
  }

  .treo{
    right: 548px;
  }
  .treth{
    right: 248px;
  }
  .tret{
    right: 380px;
  }
  .twobtn{
    /*background-color: #169BD5;*/
    /*color: white;*/
    width: 110px;
    font-size: 15px;
  }
</style>
